import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import * as Yup from "yup"
import { Button, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'

const CreateAdditionalWorkModel = ({ modal, toggle, AdditionalWorkListApi, isEdit, editData }) => {
    const { postApi, putApi } = useApi()
    const [formSumitLoading, setformSumitLoading] = useState(false)

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    //  Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            Note: isEdit ? editData?.Note : '',
        },
        validationSchema: Yup.object({
            Note: Yup.string().required("The note is required"),
        }),
        onSubmit: values => {
            setformSumitLoading(true)
            if (values) {
                postApi("Common/additional-work/addedit", {
                    id: isEdit ? editData.Id : 0,
                    Note: values.Note,
                }).then(({ data, status }) => {
                    setformSumitLoading(false)
                    if (status == 400) {
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    } else {
                        toast.success(`Sucessfully ${ isEdit ? "updated" : "created"}`, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                        setformSumitLoading(false)
                        toggle()
                        if (AdditionalWorkListApi != '') {
                            AdditionalWorkListApi()
                        }
                        validation.handleReset()
                    }
                })
            }
        },
    })


    // cancle handler
    const handleCancle = () => {
        toggle()
    }

    const [isMobile, setisMobile] = useState(window.innerWidth < 924)
    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="small"
            style={{ width: !isMobile ? "400px" : "" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    {isEdit ? "Update Additional Work" : "Create Additional Work"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            validation.handleReset()
                            return false
                        }}
                    >
                        <Row>
                            <FormGroup className="mb-2">
                                <Label htmlFor="validationCustom03" className="required">
                                    Note
                                </Label>
                                <Input
                                    name="Note"
                                    placeholder="Enter note hear"
                                    type="textarea"
                                    rows={4}
                                    className="form-control-sm"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.Note || ""}
                                    invalid={
                                        validation.touched.Note && validation.errors.Note
                                            ? true
                                            : false
                                    }
                                />
                                {validation.touched.Note && validation.errors.Note ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.Note}
                                    </FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Row>
                        <div className="text-end">
                            {isEdit ? (
                                <Button
                                    user="secondary"
                                    className="btn btn-primary me-2 btn-sm "
                                    onClick={handleCancle}
                                >
                                    Cancle
                                </Button>
                            ) : (
                                <Button
                                    user="secondary"
                                    className="btn btn-primary me-2 btn-sm "
                                    type="reset"
                                >
                                    Reset
                                </Button>
                            )}
                            {formSumitLoading ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    color="secondary"
                                >
                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    Loading
                                </button>
                            ) : (
                                <Button
                                    user="primary"
                                    className="btn btn-primary btn-sm "
                                    type="submit"
                                    color="primary"
                                >
                                    Submit
                                </Button>
                            )}
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    )
}

export default CreateAdditionalWorkModel